import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'public/environments/environment';
import { PlanSubscriptionPeriodEnum } from '../models/enums/PlanSubscriptionPeriodEnum';
import { CurrentSubscribedPlan, SubscriptionPlan } from '../models/SubscriptionPlan';

@Injectable({
  providedIn: 'root'
})
export class ConsumerSubscriptionPlanService {
  constructor(private http: HttpClient) { }

  getCurrentSubscripedPlan(planId: number): Observable<CurrentSubscribedPlan> {
    const params = { planId };
    return this.http.get<CurrentSubscribedPlan>(`${environment.apiUrl}/ConsumerSubscriptionPlan/GetCurrentSubscripedPlan`, { params });
  }

  listActivePlans(periodType: PlanSubscriptionPeriodEnum = PlanSubscriptionPeriodEnum.MONTH): Observable<SubscriptionPlan[]> {
    const params = { periodType };
    return this.http.get<SubscriptionPlan[]>(`${environment.apiUrl}/ConsumerSubscriptionPlan/ListActivePlans`, { params });
  }

  subscripeToFreePlan(data: any) {
    return this.http.post<SubscriptionPlan[]>(`${environment.apiUrl}/ConsumerSubscriptionPlan/SubscripeToFreePlan`, data);
  }

}
